import { useCallback, useSyncExternalStore } from 'react'

/**
 * Subscribes to a CSS media query. Server renders fall back to
 * `serverDefault` since there is no viewport to measure.
 */
export function useMediaQuery(query: string, serverDefault = true) {
	const subscribe = useCallback(
		(onStoreChange: () => void) => {
			const mq = window.matchMedia(query)
			mq.addEventListener('change', onStoreChange)
			return () => mq.removeEventListener('change', onStoreChange)
		},
		[query],
	)

	return useSyncExternalStore(
		subscribe,
		() => window.matchMedia(query).matches,
		() => serverDefault,
	)
}

/** Matches Tailwind's `sm` breakpoint, where DialogContent takes its desktop sizing. */
export function useIsDesktop() {
	return useMediaQuery('(min-width: 640px)')
}
